import { AccessDeniedError } from "@hm/fundamental"
import { useAuth } from "@shared/lib/auth"
import { useTraceparent } from "@shared/lib/hooks"
import { CentralizedContainerBox, TraceIdBadge } from "@shared/ui"
import React from "react"
import { useTranslation } from "react-i18next"

export const AccessDeniedPage: React.FC = () => {
	const { t } = useTranslation("pages", { keyPrefix: "accessDenied" })
	const { startLogoutFlow } = useAuth()
	const { traceId } = useTraceparent()

	return (
		<CentralizedContainerBox data-cy="access-denied-page-container">
			<div className="flex flex-col items-center">
				<AccessDeniedError
					title={t("title")}
					description={t("description")}
					className="!h-auto !pb-6"
					logoutText={t("secondaryButtonTitle")}
					onLogout={startLogoutFlow}
					data-cy="access-denied-error"
				/>
				<TraceIdBadge
					traceId={traceId}
					data-cy="access-denied-trace-id"
				/>
			</div>
		</CentralizedContainerBox>
	)
}
